import publicRoutes from './public';
import adminRoutes from './admin';
import merchantRoutes from './merchant';
import referralRoutes from './referral';

export default [
  ...publicRoutes,
  ...adminRoutes,
  ...merchantRoutes,
  ...referralRoutes,
];
